"use strict";

var _excluded = ["completeName"];

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// all keys stored in the cache by this SDK will be prefixed with this value
var CACHE_PREFIX = 'roster:'; // cached for 1 minute

var CACHE_DURATION_MIN = 1;

function SDK(baseUrl, fetch, cacheInterface, companyId) {
  var logger = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : console;

  // Private
  function _fetchJson(url, options, overrideBaseUrl) {
    return new Promise(function ($return, $error) {
      var res, data, text;

      if (options && options.body) {
        options.headers = _objectSpread(_objectSpread({}, options.headers || {}), {}, _defineProperty({}, 'Content-Type', 'application/json'));
      }

      return Promise.resolve(fetch("".concat(overrideBaseUrl ? overrideBaseUrl : baseUrl).concat(url), options)).then(function ($await_11) {
        try {
          res = $await_11;

          if (res.ok) {
            return Promise.resolve(res.json()).then($return, $error);
          } else {
            if (res.headers.get('Content-Type').indexOf('application/json') !== -1) {
              return Promise.resolve(res.json()).then(function ($await_13) {
                try {
                  data = $await_13;
                  logger.error({
                    status: res.status,
                    data: data
                  }, 'unsuccessful request to roster.');
                  return $error(_objectSpread({
                    status: res.status
                  }, data));
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }, $error);
            }

            return Promise.resolve(res.text()).then(function ($await_14) {
              try {
                text = $await_14;
                logger.error({
                  status: res.status,
                  text: text
                }, 'unsuccessful request to roster.');
                return $error(text);
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }, $error);
          }

          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this), $error);
    });
  }

  var getKey = function getKey(key) {
    if (companyId) {
      return "".concat(CACHE_PREFIX).concat(companyId, ":").concat(key);
    }

    return "".concat(CACHE_PREFIX).concat(key);
  };

  var _cacheGet = function _cacheGet(key) {
    return cacheInterface.get(getKey(key));
  };

  var _cacheSet = function _cacheSet(key, value, ttl) {
    return cacheInterface.set(getKey(key), value, ttl);
  };

  var _cacheRemove = function _cacheRemove(key) {
    return cacheInterface.remove(getKey(key));
  };

  var _cacheClear = function _cacheClear() {
    return cacheInterface.clear();
  };

  var search = function search(filter) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, key, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "persons-search-".concat(JSON.stringify(filter));
      cached = _cacheGet(key);

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson('/search', _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(filter)
      }))).then(function ($await_15) {
        try {
          response = $await_15;
          return $return(_cacheSet(key, response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var fallbackSearchCompleteName = function fallbackSearchCompleteName(_ref) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var completeName, personProperties, _ref$sortedOn, sortedOn, _ref$sortedBy, sortedBy, fetchOptions, filterSet, splitNames, i, personIdMap, persons;

      completeName = _ref.completeName, personProperties = _ref.personProperties, _ref$sortedOn = _ref.sortedOn, sortedOn = _ref$sortedOn === void 0 ? null : _ref$sortedOn, _ref$sortedBy = _ref.sortedBy, sortedBy = _ref$sortedBy === void 0 ? null : _ref$sortedBy;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      filterSet = [{
        firstName: completeName
      }, {
        lastName: completeName
      }];
      splitNames = completeName.trim().split(' ');

      for (i = 1; i <= splitNames.length; i++) {
        filterSet.push({
          firstName: splitNames.slice(0, i).join(' '),
          lastName: splitNames.slice(i).join(' ')
        });
      }

      personIdMap = {};
      return Promise.resolve(filterSet.map(function (filter) {
        return new Promise(function ($return, $error) {
          var response;
          return Promise.resolve(search(_objectSpread(_objectSpread({
            personProperties: personProperties,
            sortedOn: sortedOn,
            sortedBy: sortedBy
          }, filter), {}, {
            pageSize: 1001,
            // if result is over 1000 error will be thrown in controller
            pageNumber: 1
          }), fetchOptions)).then(function ($await_16) {
            try {
              response = $await_16;

              if (response.success) {
                if (response.persons.length > 1000) {
                  return $error(new Error('exceeds 1000 results'));
                } // get unique persons


                return $return(response.persons.forEach(function (p) {
                  return personIdMap[p.id] = p;
                }));
              }

              return $error(new Error('Unsuccessful response from search'));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        });
      })).then(function ($await_17) {
        try {
          return Promise.resolve(Promise.all($await_17)).then(function ($await_18) {
            try {
              persons = Object.values(personIdMap);
              return $return({
                success: true,
                pageNumber: 1,
                pageSize: 1001,
                recordCount: persons.length,
                sortedOn: sortedOn,
                sortedBy: sortedBy,
                personProperties: personProperties,
                persons: persons
              });
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var searchByCompleteName = function searchByCompleteName(filters) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, searchResponse, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      searchResponse = {};

      var $Try_1_Post = function () {
        try {
          if (filters.pageSize === 1001 && searchResponse.persons.length > 1000) {
            return $error(new Error('exceeds 1000 results'));
          }

          return $return(searchResponse);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      var $Try_1_Catch = function (error) {
        try {
          return Promise.resolve(fallbackSearchCompleteName(filters, fetchOptions)).then(function ($await_19) {
            try {
              // if that fails split name and search by that
              searchResponse = $await_19;
              return $Try_1_Post();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      // try searching by complete name
      try {
        return Promise.resolve(search(filters, fetchOptions)).then(function ($await_20) {
          try {
            response = $await_20;

            if (!response.success) {
              throw new Error('Unsuccessful response from search');
            }

            if (filters.pageSize === 1001 && response.persons.length > 1000) {
              throw new Error('exceeds 1000 results');
            }

            searchResponse = response;
            return $Try_1_Post();
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error)
      }
    });
  };

  var searchPersonByProperty = function searchPersonByProperty(filters) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      return Promise.resolve(search(_objectSpread(_objectSpread({}, filters), {}, {
        pageSize: 1001,
        // if result is over 1000 error will be thrown in controller
        pageNumber: 1
      }), fetchOptions)).then(function ($await_21) {
        try {
          response = $await_21;

          if (response.success) {
            if (response.persons.length > 1000) {
              return $error(new Error('exceeds 1000 results'));
            }

            return $return(response);
          }

          return $error(new Error('Unsuccessful response from search'));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }; // require companyId in case its not passed into cache


  var isDigsImplementation = function isDigsImplementation(companyId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, companyRoster;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};

      var $Try_2_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      var $Try_2_Catch = function (error) {
        try {
          if (error.responseCode === 404) {
            return $return(true);
          }

          throw error;
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      try {
        return Promise.resolve(_fetchJson("/companyroster/".concat(companyId), _objectSpread({}, fetchOptions), "".concat(baseUrl, "-proxy-admin"))).then(function ($await_22) {
          try {
            companyRoster = $await_22;

            if (companyRoster) {
              return $return(false);
            }

            return $Try_2_Post();
          } catch ($boundEx) {
            return $Try_2_Catch($boundEx);
          }
        }, $Try_2_Catch);
      } catch (error) {
        $Try_2_Catch(error)
      }
    });
  };

  var getPersonAttributeTypes = function getPersonAttributeTypes() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
      cached = _cacheGet('person-attributes');

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson('/persons/attributes', _objectSpread({}, fetchOptions))).then(function ($await_23) {
        try {
          response = $await_23;
          return $return(_cacheSet('person-attributes', response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getDistinctPersonAttributeValues = function getDistinctPersonAttributeValues(attributeId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      cached = _cacheGet("person-attributes-".concat(attributeId));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/persons/attributes/".concat(encodeURIComponent(attributeId), "/values"), _objectSpread({}, fetchOptions))).then(function ($await_24) {
        try {
          response = $await_24;
          return $return(_cacheSet("person-attributes-".concat(attributeId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postPersonAttributeTypes = function postPersonAttributeTypes(attributeType) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      return Promise.resolve(_fetchJson('/persons/attributes', _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(attributeType)
      }))).then(function ($await_25) {
        try {
          response = $await_25;

          _cacheRemove('person-attributes');

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getPerson = function getPerson(personId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      cached = _cacheGet("person-".concat(personId));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId)), _objectSpread({}, fetchOptions))).then(function ($await_26) {
        try {
          response = $await_26;
          return $return(_cacheSet("person-".concat(personId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getPersonDetailed = function getPersonDetailed(personId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var _ref2, personProperties, fetchOptions, detailPersonJson, cached, response;

      _ref2 = $args.length > 1 && $args[1] !== undefined ? $args[1] : {}, personProperties = _ref2.personProperties;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      detailPersonJson = JSON.stringify({
        personId: personId,
        personProperties: personProperties
      });
      cached = _cacheGet("person-detailed-".concat(detailPersonJson));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId), "/detailed"), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify({
          personProperties: personProperties
        })
      }))).then(function ($await_27) {
        try {
          response = $await_27;
          return $return(_cacheSet("person-detailed-".concat(detailPersonJson), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getPersonExternal = function getPersonExternal(externalId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      cached = _cacheGet("person-external-".concat(encodeURIComponent(externalId)));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/persons/external-id/".concat(encodeURIComponent(externalId)), _objectSpread({}, fetchOptions))).then(function ($await_28) {
        try {
          response = $await_28;
          return $return(_cacheSet("person-external-".concat(externalId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postPerson = function postPerson(person) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      return Promise.resolve(_fetchJson('/persons', _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(person)
      }))).then(function ($await_29) {
        try {
          response = $await_29;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postPersonComplete = function postPersonComplete(completePerson) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      return Promise.resolve(_fetchJson('/persons/complete', _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(completePerson)
      }))).then(function ($await_30) {
        try {
          response = $await_30;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var putPerson = function putPerson(personId, person) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'PUT',
        body: JSON.stringify(person)
      }))).then(function ($await_31) {
        try {
          response = $await_31;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  /**
   * search all persons within a company by certain filters
   * @param {Object[]} filter
   * @param {String} filter[].emailAddress
   * @param {String} filter[].firstName
   * @param {String} filter[].hierarchyNodeId
   * @param {String} filter[].languagePreference
   * @param {String} filter[].lastName
   * @param {String} filter[].pageNumber
   * @param {String} filter[].pageSize
   * @param {String} filter[].personAddressCountry
   * @param {Object} filter[].personAttributes
   * @param {String} filter[].personCountry
   * @param {String} filter[].personId
   * @param {String[]} filter[].personProperties
   * @param {String} filter[].phoneNumber
   * @param {String} filter[].roleType
   * @param {String} filter[].sortedBy
   * @param {String} filter[].sortedOn
   * @param {String} filter[].state
   * @param {String} filter[].username
   */


  var searchPersons = function searchPersons(filters) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, nonPersonCriteria, completeName, filtersWithoutCompleteName;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      nonPersonCriteria = ['pageSize', 'pageNumber', 'personProperties', 'sortedBy', 'sortedOn'];

      if (filters.completeName) {
        // check if there is other person criteria besides just complete name
        if (Object.keys(filters).some(function (key) {
          return ![].concat(nonPersonCriteria, ['completeName']).includes(key);
        })) {
          // if there is other person criteria, try search with completeName
          try {
            return $return(search(filters, fetchOptions));
          } catch (error) {
            completeName = filters.completeName, filtersWithoutCompleteName = _objectWithoutProperties(filters, _excluded);

            // if that fails but other name criteria is supplied search by those without complete name
            if (filtersWithoutCompleteName.firstName || filtersWithoutCompleteName.lastName) {
              return $return(search(filtersWithoutCompleteName, fetchOptions));
            } else {
              // if that fails - fallback to searching by firstName as a last resort
              return $return(search(_objectSpread({
                firstName: completeName
              }, filtersWithoutCompleteName), fetchOptions));
            }
          }

          return $If_7.call(this);
        } else {
          return Promise.resolve(searchByCompleteName(filters, fetchOptions)).then($return, $error);
        }

        function $If_7() {
          return $If_6.call(this);
        }

        return $If_7.call(this);
      } // if it does not include complete name, use search as is


      function $If_6() {
        return $return(search(filters, fetchOptions));
      }

      return $If_6.call(this);
    });
  };

  var fullPersonsSearch = function fullPersonsSearch(filters) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, pageNumber, keepSearching, success, persons, personProperties, sortedOn, sortedBy, searchResults;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      pageNumber = 1;
      keepSearching = true;
      success = true;
      persons = [];
      personProperties = undefined;
      sortedOn = undefined;
      sortedBy = undefined;
      var $Loop_8_trampoline;

      function $Loop_8() {
        if (keepSearching) {
          return Promise.resolve(searchPersons(_objectSpread(_objectSpread({}, filters), {}, {
            pageNumber: pageNumber,
            pageSize: 500
          }), fetchOptions)).then(function ($await_33) {
            try {
              searchResults = $await_33;
              success = success || searchResults.success;
              persons = persons.concat(searchResults.persons);
              personProperties = searchResults.personProperties;
              sortedOn = searchResults.sortedOn;
              sortedBy = searchResults.sortedBy;
              pageNumber++; // TODO: Take out 10,000 limit when digs is updated

              if (!searchResults.pageNumber || !searchResults.pageSize || searchResults.pageNumber * searchResults.pageSize >= Math.min(100000, searchResults.recordCount)) {
                keepSearching = false;
              }

              return $Loop_8;
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } else return [1];
      }

      return ($Loop_8_trampoline = function (q) {
        while (q) {
          if (q.then) return void q.then($Loop_8_trampoline, $error);

          try {
            if (q.pop) {
              if (q.length) return q.pop() ? $Loop_8_exit.call(this) : q;else q = $Loop_8;
            } else q = q.call(this);
          } catch (_exception) {
            return $error(_exception);
          }
        }
      }.bind(this))($Loop_8);

      function $Loop_8_exit() {
        // return the same structure as searchPersons - pageNumber & pageSize
        return $return({
          success: success,
          recordCount: persons.length,
          sortedOn: sortedOn,
          sortedBy: sortedBy,
          personProperties: personProperties,
          persons: persons
        });
      }
    });
  };

  var genericSearchPersons = function genericSearchPersons(_ref3) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var searchInput, searchByProperties, _ref3$personPropertie, personProperties, _ref3$sortedOn, sortedOn, _ref3$sortedBy, sortedBy, fetchOptions, key, cached, personIdMap, persons, fullResponse;

      searchInput = _ref3.searchInput, searchByProperties = _ref3.searchByProperties, _ref3$personPropertie = _ref3.personProperties, personProperties = _ref3$personPropertie === void 0 ? [] : _ref3$personPropertie, _ref3$sortedOn = _ref3.sortedOn, sortedOn = _ref3$sortedOn === void 0 ? null : _ref3$sortedOn, _ref3$sortedBy = _ref3.sortedBy, sortedBy = _ref3$sortedBy === void 0 ? null : _ref3$sortedBy;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};

      if (!searchByProperties || !Array.isArray(searchByProperties) || searchByProperties.length === 0) {
        return $error(new Error('missing search properties'));
      }

      key = "generic-search-persons-".concat(JSON.stringify({
        searchInput: searchInput,
        searchByProperties: searchByProperties,
        personProperties: personProperties,
        sortedOn: sortedOn,
        sortedBy: sortedBy
      }));
      cached = _cacheGet(key);

      if (cached) {
        return $return(cached);
      }

      personIdMap = {};
      return Promise.resolve(searchByProperties.map(function (property) {
        return new Promise(function ($return, $error) {
          var response, _searchPersonByProper;

          if (property === 'completeName') {
            return Promise.resolve(searchByCompleteName({
              completeName: searchInput,
              personProperties: personProperties,
              pageSize: 1001,
              pageNumber: 1,
              sortedOn: sortedOn,
              sortedBy: sortedBy
            }, fetchOptions)).then(function ($await_34) {
              try {
                response = $await_34; //limit for generic search

                return $If_10.call(this);
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }.bind(this), $error);
          } else {
            return Promise.resolve(searchPersonByProperty((_searchPersonByProper = {}, _defineProperty(_searchPersonByProper, property, searchInput), _defineProperty(_searchPersonByProper, "personProperties", personProperties), _defineProperty(_searchPersonByProper, "sortedOn", sortedOn), _defineProperty(_searchPersonByProper, "sortedBy", sortedBy), _searchPersonByProper), fetchOptions)).then(function ($await_35) {
              try {
                response = $await_35;
                return $If_10.call(this);
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }.bind(this), $error);
          }

          function $If_10() {
            response.persons.forEach(function (p) {
              return personIdMap[p.id] = p;
            });
            return $return();
          }
        });
      })).then(function ($await_36) {
        try {
          return Promise.resolve(Promise.all($await_36)).then(function ($await_37) {
            try {
              persons = Object.values(personIdMap);
              fullResponse = {
                success: true,
                pageNumber: 1,
                pageSize: 1001,
                recordCount: persons.length,
                sortedOn: sortedOn,
                sortedBy: sortedBy,
                personProperties: personProperties,
                persons: persons
              };
              return $return(_cacheSet(key, fullResponse, CACHE_DURATION_MIN));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getPersonAttributes = function getPersonAttributes(personId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      cached = _cacheGet("attribute-".concat(personId));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/persons/".concat(personId, "/attributes"), _objectSpread({}, fetchOptions))).then(function ($await_38) {
        try {
          response = $await_38;
          return $return(_cacheSet("attribute-".concat(personId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postPersonAttribute = function postPersonAttribute(personId, attribute) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId), "/attributes"), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(attribute)
      }))).then(function ($await_39) {
        try {
          response = $await_39;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var putPersonAttribute = function putPersonAttribute(personId, attributeName, attributeValue) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 3 && $args[3] !== undefined ? $args[3] : {};
      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId), "/attributes/").concat(encodeURIComponent(attributeName)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'PUT',
        body: JSON.stringify({
          name: attributeName,
          value: attributeValue
        })
      }))).then(function ($await_40) {
        try {
          response = $await_40;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getPersonEmailAddresses = function getPersonEmailAddresses(personId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      cached = _cacheGet("email-addresses-".concat(personId));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/persons/".concat(personId, "/email-addresses"), _objectSpread({}, fetchOptions))).then(function ($await_41) {
        try {
          response = $await_41;
          return $return(_cacheSet("email-addresses-".concat(personId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postPersonEmailAddress = function postPersonEmailAddress(personId, emailAddress) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId), "/email-addresses"), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(emailAddress)
      }))).then(function ($await_42) {
        try {
          response = $await_42;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var putPersonEmailAddress = function putPersonEmailAddress(personId, emailAddressId, emailAddress) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 3 && $args[3] !== undefined ? $args[3] : {};
      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId), "/email-addresses/").concat(encodeURIComponent(emailAddressId)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'PUT',
        body: JSON.stringify(emailAddress)
      }))).then(function ($await_43) {
        try {
          response = $await_43;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getPersonPushNotifications = function getPersonPushNotifications(personId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      cached = _cacheGet("push-notifications-".concat(personId));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId), "/push-notification-subscriptions"), _objectSpread({}, fetchOptions))).then(function ($await_44) {
        try {
          response = $await_44;
          return $return(_cacheSet("push-notifications-".concat(personId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postPersonPushNotifications = function postPersonPushNotifications(personId, label, token) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 3 && $args[3] !== undefined ? $args[3] : {};
      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId), "/push-notification-subscriptions"), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify({
          label: label,
          token: token
        })
      }))).then(function ($await_45) {
        try {
          response = $await_45;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var putPersonPushNotifications = function putPersonPushNotifications(personId, subscriptionId, label, token) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 4 && $args[4] !== undefined ? $args[4] : {};
      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId), "/push-notification-subscriptions/").concat(encodeURIComponent(subscriptionId)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'PUT',
        body: JSON.stringify({
          label: label,
          token: token
        })
      }))).then(function ($await_46) {
        try {
          response = $await_46;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var deletePersonPushNotifications = function deletePersonPushNotifications(personId, subscriptionId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId), "/push-notification-subscriptions/").concat(encodeURIComponent(subscriptionId)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'DELETE'
      }))).then(function ($await_47) {
        try {
          response = $await_47;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getGroups = function getGroups() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
      cached = _cacheGet('groups');

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson('/groups', _objectSpread({}, fetchOptions))).then(function ($await_48) {
        try {
          response = $await_48;
          return $return(_cacheSet('groups', response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postGroup = function postGroup(group) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      return Promise.resolve(_fetchJson('/groups', _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(group)
      }))).then(function ($await_49) {
        try {
          response = $await_49;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postFixedGroup = function postFixedGroup(group) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      return Promise.resolve(_fetchJson('/groups/fixed', _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(group)
      }))).then(function ($await_50) {
        try {
          response = $await_50;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }; // searchParams can be one or more of the following: { groupId: 'string', name: 'string', type: 'string' }


  var searchGroups = function searchGroups(searchParams) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      cached = _cacheGet("groups-search-".concat(JSON.stringify(searchParams)));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson('/groups/search', _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(searchParams)
      }))).then(function ($await_51) {
        try {
          response = $await_51;
          return $return(_cacheSet("groups-search-".concat(JSON.stringify(searchParams)), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getGroup = function getGroup(groupId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      cached = _cacheGet("group-".concat(groupId));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/groups/".concat(encodeURIComponent(groupId)), _objectSpread({}, fetchOptions))).then(function ($await_52) {
        try {
          response = $await_52;
          return $return(_cacheSet("group-".concat(groupId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var putGroup = function putGroup(groupId, group) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      return Promise.resolve(_fetchJson("/groups/".concat(encodeURIComponent(groupId)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'PUT',
        body: JSON.stringify(group)
      }))).then(function ($await_53) {
        try {
          response = $await_53;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var putFixedGroup = function putFixedGroup(groupId, group) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      return Promise.resolve(_fetchJson("/groups/fixed/".concat(encodeURIComponent(groupId)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'PUT',
        body: JSON.stringify(group)
      }))).then(function ($await_54) {
        try {
          response = $await_54;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var deleteGroup = function deleteGroup(groupId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      return Promise.resolve(_fetchJson("/groups/".concat(encodeURIComponent(groupId)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'DELETE'
      }))).then(function ($await_55) {
        try {
          response = $await_55;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getGroupPersons = function getGroupPersons(groupId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      cached = _cacheGet("group-persons-".concat(groupId));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/groups/".concat(encodeURIComponent(groupId), "/persons"), _objectSpread({}, fetchOptions))).then(function ($await_56) {
        try {
          response = $await_56;
          return $return(_cacheSet("group-persons-".concat(groupId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getGroupPersonsPaginated = function getGroupPersonsPaginated(groupId, options) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      cached = _cacheGet("group-persons-".concat(groupId, "-").concat(JSON.stringify(options)));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/groups/".concat(encodeURIComponent(groupId), "/persons"), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(_objectSpread({}, options))
      }))).then(function ($await_57) {
        try {
          response = $await_57;
          return $return(_cacheSet("group-persons-".concat(groupId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var searchHierarchies = function searchHierarchies(hierarchyName) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      cached = _cacheGet("hierarchy-search-".concat(hierarchyName));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson('/hierarchies/search', _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify({
          name: hierarchyName
        })
      }))).then(function ($await_58) {
        try {
          response = $await_58;
          return $return(_cacheSet("hierarchy-search-".concat(hierarchyName), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var searchHierarchyNodes = function searchHierarchyNodes(hierarchyId, searchOptions) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, key, cached, response;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      key = "hierarchy-node-search-".concat(hierarchyId, "-").concat(JSON.stringify(searchOptions));
      cached = _cacheGet(key);

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/hierarchies/".concat(hierarchyId, "/nodes/search"), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(searchOptions)
      }))).then(function ($await_59) {
        try {
          response = $await_59;
          return $return(_cacheSet(key, response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getHierarchies = function getHierarchies() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
      cached = _cacheGet('hierarchies');

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson('/hierarchies', _objectSpread({}, fetchOptions))).then(function ($await_60) {
        try {
          response = $await_60;
          return $return(_cacheSet('hierarchies', response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getHierarchy = function getHierarchy(hierarchyId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      cached = _cacheGet("hierarchy-".concat(hierarchyId));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/hierarchies/".concat(encodeURIComponent(hierarchyId)), _objectSpread({}, fetchOptions))).then(function ($await_61) {
        try {
          response = $await_61;
          return $return(_cacheSet("hierarchy-".concat(hierarchyId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postHierarchy = function postHierarchy(hierarchy) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      return Promise.resolve(_fetchJson('/hierarchies', _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(hierarchy)
      }))).then(function ($await_62) {
        try {
          response = $await_62;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getHierarchyNodeAttributeTypes = function getHierarchyNodeAttributeTypes() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
      cached = _cacheGet('hierarchy-nodes-attributes');

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson('/hierarchies/nodes/attributes', _objectSpread({}, fetchOptions))).then(function ($await_63) {
        try {
          response = $await_63;
          return $return(_cacheSet('hierarchy-nodes-attributes', response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getDistinctHierarchyNodeAttributeValues = function getDistinctHierarchyNodeAttributeValues(hierarchyId, attributeId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      cached = _cacheGet("hierarchy-nodes-attributes-".concat(hierarchyId, "-").concat(attributeId));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/hierarchy/".concat(encodeURIComponent(hierarchyId), "/nodes/").concat(encodeURIComponent(attributeId), "/values"), _objectSpread({}, fetchOptions))).then(function ($await_64) {
        try {
          response = $await_64;
          return $return(_cacheSet("hierarchy-nodes-attributes-".concat(hierarchyId, "-").concat(attributeId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postHierarchyNodeAttributeType = function postHierarchyNodeAttributeType(attributeType) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      return Promise.resolve(_fetchJson('/hierarchy/nodes/attributes', _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(attributeType)
      }))).then(function ($await_65) {
        try {
          response = $await_65;

          _cacheRemove('hierarchy-nodes-attributes');

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postHierarchyNode = function postHierarchyNode(hierarchyId, node) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      return Promise.resolve(_fetchJson("/hierarchies/".concat(encodeURIComponent(hierarchyId), "/nodes"), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(node)
      }))).then(function ($await_66) {
        try {
          response = $await_66;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getHierarchyNodes = function getHierarchyNodes(hierarchyId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      cached = _cacheGet("hierarchy-nodes-".concat(hierarchyId));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/hierarchies/".concat(encodeURIComponent(hierarchyId), "/nodes"), _objectSpread({}, fetchOptions))).then(function ($await_67) {
        try {
          response = $await_67;
          return $return(_cacheSet("hierarchy-nodes-".concat(hierarchyId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var getHierarchyNode = function getHierarchyNode(hierarchyId, hierarchyNodeId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, cached, response;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      cached = _cacheGet("hierarchy-node-".concat(hierarchyId, "-").concat(hierarchyNodeId));

      if (cached) {
        return $return(cached);
      }

      return Promise.resolve(_fetchJson("/hierarchies/".concat(encodeURIComponent(hierarchyId), "/nodes/").concat(encodeURIComponent(hierarchyNodeId)), _objectSpread({}, fetchOptions))).then(function ($await_68) {
        try {
          response = $await_68;
          return $return(_cacheSet("hierarchy-node-".concat(hierarchyId, "-").concat(hierarchyNodeId), response, CACHE_DURATION_MIN));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postHierarchyNodeAttribute = function postHierarchyNodeAttribute(hierarchyId, hierarchyNodeId, attribute) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, url, response;
      fetchOptions = $args.length > 3 && $args[3] !== undefined ? $args[3] : {};
      url = "/hierarchy/".concat(encodeURIComponent(hierarchyId), "/nodes/").concat(encodeURIComponent(hierarchyNodeId), "/attributes");
      return Promise.resolve(_fetchJson(url, _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST',
        body: JSON.stringify(attribute)
      }))).then(function ($await_69) {
        try {
          response = $await_69;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var addPersonToHierarchyNode = function addPersonToHierarchyNode(personId, hierarchyNodeId, roleType) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 3 && $args[3] !== undefined ? $args[3] : {};
      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId), "/nodes/").concat(encodeURIComponent(hierarchyNodeId), "/").concat(encodeURIComponent(roleType)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'POST'
      }))).then(function ($await_70) {
        try {
          response = $await_70;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var removePersonFromHierarchyNode = function removePersonFromHierarchyNode(personId, hierarchyNodeId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var fetchOptions, response;
      fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      return Promise.resolve(_fetchJson("/persons/".concat(encodeURIComponent(personId), "/nodes/").concat(encodeURIComponent(hierarchyNodeId)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'DELETE'
      }))).then(function ($await_71) {
        try {
          response = $await_71;

          _cacheClear();

          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  var postPassword = function postPassword(personId, newPassword, passwordRepeatLimit) {
    var fetchOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var verificationToken = arguments.length > 4 ? arguments[4] : undefined;
    return _fetchJson("/persons/".concat(encodeURIComponent(personId), "/password"), _objectSpread(_objectSpread({}, fetchOptions), {}, {
      method: 'PUT',
      body: JSON.stringify({
        newPassword: newPassword,
        passwordRepeatLimit: passwordRepeatLimit,
        verificationToken: verificationToken
      })
    }));
  };

  var authenticate = function authenticate(userId, password) {
    var fetchOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _fetchJson('/persons/authenticate', _objectSpread(_objectSpread({}, fetchOptions), {}, {
      method: 'POST',
      body: JSON.stringify({
        userId: userId,
        password: password
      })
    }));
  };

  var personProperties = {
    emails: 'emails',
    addresses: 'addresses',
    phones: 'phones',
    groups: 'groups',
    nodes: 'nodes',
    attributes: 'attributes'
  };

  var getAttributeValue = function getAttributeValue(attributes, attributeName) {
    if (attributes && attributes.length > 0) {
      var match = attributes.find(function (attribute) {
        return attribute.name.toLowerCase() === attributeName.toLowerCase();
      });

      if (match) {
        return match.value;
      }
    }
  };
  /**
   * get single email address from array - default preference is business, personal, other and first entry in array
   * @param {Object[]} emails
   * @param {string} emails[].label - type of email address such as business or personal
   * @param {string} emails[].address - email address
   * @param {string} emails[].id - id of email address
   *
   * @param {string} [preferredLabel] - label that will override default preferences
   * @param {boolean} [fallback] - returns the prefered label email address and no fallback email address when set to false
   */


  var getPrimaryEmailAddressFromSet = function getPrimaryEmailAddressFromSet(emails, preferredLabel) {
    var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!emails || emails.length < 1) {
      return undefined;
    }

    if (preferredLabel) {
      var preferredEmail = emails.find(function (email) {
        return email.label.toLowerCase() === preferredLabel.toLowerCase();
      });

      if (preferredEmail) {
        return preferredEmail.address;
      }

      if (!fallback) {
        return undefined;
      }
    }

    var businessEmail = emails.find(function (email) {
      return email.label.toLowerCase() === 'business';
    });

    if (businessEmail) {
      return businessEmail.address;
    }

    var personalEmail = emails.find(function (email) {
      return email.label.toLowerCase() === 'personal';
    });

    if (personalEmail) {
      return personalEmail.address;
    }

    var otherEmail = emails.find(function (email) {
      return email.label.toLowerCase() === 'other';
    });

    if (otherEmail) {
      return otherEmail.address;
    }

    return emails[0].address;
  };

  var getPrimaryPhoneNumberFromSet = function getPrimaryPhoneNumberFromSet(phones, preferredLabel) {
    var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!phones || phones.length < 1) {
      return undefined;
    }

    if (preferredLabel) {
      var preferredPhone = phones.find(function (phone) {
        return phone.label.toLowerCase() === preferredLabel.toLowerCase();
      });

      if (preferredPhone) {
        return preferredPhone;
      }

      if (!fallback) {
        return undefined;
      }
    }

    var businessPhone = phones.find(function (phone) {
      return phone.label.toLowerCase() === 'business';
    });

    if (businessPhone) {
      return businessPhone;
    }

    var personalPhone = phones.find(function (phone) {
      return phone.label.toLowerCase() === 'personal';
    });

    if (personalPhone) {
      return personalPhone;
    }

    var otherPhone = phones.find(function (phone) {
      return phone.label.toLowerCase() === 'other';
    });

    if (otherPhone) {
      return otherPhone;
    }

    return phones[0];
  };

  var getPrimaryAddressFromSet = function getPrimaryAddressFromSet(addresses, preferredLabel) {
    var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!addresses || addresses.length < 1) {
      return undefined;
    }

    if (preferredLabel) {
      var preferredAddress = addresses.find(function (address) {
        return address.label.toLowerCase() === preferredLabel.toLowerCase();
      });

      if (preferredAddress) {
        return preferredAddress;
      }

      if (!fallback) {
        return undefined;
      }
    }

    var businessAddress = addresses.find(function (address) {
      return address.label.toLowerCase() === 'business';
    });

    if (businessAddress) {
      return businessAddress;
    }

    var personalAddress = addresses.find(function (address) {
      return address.label.toLowerCase() === 'home';
    });

    if (personalAddress) {
      return personalAddress;
    }

    var shippingAddress = addresses.find(function (address) {
      return address.label.toLowerCase() === 'shipping';
    });

    if (shippingAddress) {
      return shippingAddress;
    }

    var otherAddress = addresses.find(function (address) {
      return address.label.toLowerCase() === 'other';
    });

    if (otherAddress) {
      return otherAddress;
    }

    return addresses[0];
  };

  var getHierarchyNodeRoleTypes = function getHierarchyNodeRoleTypes() {
    return ['owner', 'member', 'manager'];
  };

  var getStatusTypes = function getStatusTypes() {
    return ['active', 'inactive'];
  };

  return {
    isDigsImplementation: isDigsImplementation,
    getPersonAttributeTypes: getPersonAttributeTypes,
    getDistinctPersonAttributeValues: getDistinctPersonAttributeValues,
    postPersonAttributeTypes: postPersonAttributeTypes,
    getPerson: getPerson,
    getPersonDetailed: getPersonDetailed,
    getPersonExternal: getPersonExternal,
    postPerson: postPerson,
    postPersonComplete: postPersonComplete,
    putPerson: putPerson,
    searchPersons: searchPersons,
    fullPersonsSearch: fullPersonsSearch,
    genericSearchPersons: genericSearchPersons,
    getPersonAttributes: getPersonAttributes,
    postPersonAttribute: postPersonAttribute,
    putPersonAttribute: putPersonAttribute,
    getPersonEmailAddresses: getPersonEmailAddresses,
    postPersonEmailAddress: postPersonEmailAddress,
    putPersonEmailAddress: putPersonEmailAddress,
    getPersonPushNotifications: getPersonPushNotifications,
    postPersonPushNotifications: postPersonPushNotifications,
    putPersonPushNotifications: putPersonPushNotifications,
    deletePersonPushNotifications: deletePersonPushNotifications,
    getGroups: getGroups,
    postGroup: postGroup,
    postFixedGroup: postFixedGroup,
    searchGroups: searchGroups,
    getGroup: getGroup,
    putGroup: putGroup,
    putFixedGroup: putFixedGroup,
    deleteGroup: deleteGroup,
    getGroupPersons: getGroupPersons,
    getGroupPersonsPaginated: getGroupPersonsPaginated,
    searchHierarchies: searchHierarchies,
    searchHierarchyNodes: searchHierarchyNodes,
    getHierarchies: getHierarchies,
    getHierarchy: getHierarchy,
    postHierarchy: postHierarchy,
    getHierarchyNodeAttributeTypes: getHierarchyNodeAttributeTypes,
    getDistinctHierarchyNodeAttributeValues: getDistinctHierarchyNodeAttributeValues,
    postHierarchyNodeAttributeType: postHierarchyNodeAttributeType,
    postHierarchyNode: postHierarchyNode,
    getHierarchyNodes: getHierarchyNodes,
    getHierarchyNode: getHierarchyNode,
    postHierarchyNodeAttribute: postHierarchyNodeAttribute,
    addPersonToHierarchyNode: addPersonToHierarchyNode,
    removePersonFromHierarchyNode: removePersonFromHierarchyNode,
    postPassword: postPassword,
    authenticate: authenticate,
    personProperties: personProperties,
    getAttributeValue: getAttributeValue,
    getPrimaryEmailAddressFromSet: getPrimaryEmailAddressFromSet,
    getPrimaryPhoneNumberFromSet: getPrimaryPhoneNumberFromSet,
    getPrimaryAddressFromSet: getPrimaryAddressFromSet,
    getHierarchyNodeRoleTypes: getHierarchyNodeRoleTypes,
    getStatusTypes: getStatusTypes
  };
}

var noCache = {
  get: function get() {
    return undefined;
  },
  set: function set(key, value, lifetimeMins) {
    return value;
  },
  remove: function remove(key) {
    return undefined;
  },
  clear: function clear() {
    return undefined;
  }
};

module.exports = function (url, customFetch) {
  var cacheInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noCache;
  var companyId = arguments.length > 3 ? arguments[3] : undefined;

  if (typeof customFetch !== 'function') {
    throw new Error("".concat(_typeof(customFetch), " is not a function"));
  }

  return new SDK(url, customFetch, cacheInterface, companyId);
};
//# sourceMappingURL=index.js.map